import { useEffect, useRef } from "react";

export function useHtmlCellImageAutosize(apiRef: React.RefObject<any>) {
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hasAutosized = useRef(false);

  useEffect(() => {
    // Reset the guard whenever new rows are set (new page, filter, sort, etc.)
    const unsubscribe = apiRef.current?.subscribeEvent("rowsSet", () => {
      hasAutosized.current = false;
    });

    const handleLoad = (e: Event) => {
      const target = e.target;
      if (!(target instanceof HTMLImageElement)) return;
      if (!target.classList.contains("html-cell-image")) return;
      if (hasAutosized.current) return; // guard against re-render loop

      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        hasAutosized.current = true;
        apiRef.current.autosizeColumns({ includeOutliers: true });
      }, 300);
    };

    // load events don't bubble, so use capture phase
    document.addEventListener("load", handleLoad, true);

    return () => {
      document.removeEventListener("load", handleLoad, true);
      if (debounceRef.current) clearTimeout(debounceRef.current);
      unsubscribe?.();
    };
  }, [apiRef]);
}
